import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import Logo from '../../images/logo_usi.svg';

export default class SecondaryFooter extends Component{
  render(){
    return(
      <div className="container-fluid section" id="secondary-footer">
        <div className="container">
          <div className="col-sm-12">
            <div className="row">
              <div className="col-sm-4 col-md-3 text-center" id="social">
                <h3>Suivez-nous</h3>
                <div className="row">
                  <div className="col-sm-3">
                    <Link to="#" target="_blank" rel="noopener">
                      <div id="icons_yt" className="float-right"></div>
                    </Link>
                  </div>
                  <div className="col-sm-7 text-left">
                    youtube.com/menfp_usi
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-3">
                    <Link to="#" target="_blank" rel="noopener">
                      <div id="icons_tw" className="float-right"></div>
                    </Link>
                  </div>
                  <div className="col-sm-7 text-left">
                    twitter.com/menfp_usi
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-3">
                    <Link to="#" target="_blank" rel="noopener">
                      <div id="icons_insta" className="float-right"></div>
                    </Link>
                  </div>
                  <div className="col-sm-7 text-left">
                    instagram.com/menfp_usi
                  </div>
                </div>
              </div>
              <div className="col-sm-4 col-md-6" id="news">
                <div>
                  <h3>Abonnez-vous &agrave; notre lettre d'information</h3>
                  <p>
                    Inscrivez-vous et recevez des informations sur<br />les projets actuels et futurs de l'USI / MENFP
                  </p>
                  <div className="form-inline">
                    <div className="input-group">
                      <input className="form-control" type="text" name="email" placeholder="e-mail" />
                      <input className="input-group-addon" type="submit" value="Inscrivez-vous" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-4 col-md-3">
                <img src={ Logo } alt="" className="logo" />
                <Link to="tel:(509) 00.00.00.00">(509) 00.00.00.00</Link>
                <p>
                  Rue Duncombre #29 <br className="xs-hidden" />
                  Port-au-Prince, HaÏti
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Views/Components/SecondaryFooter.js